import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Slider from 'react-slick'
import s from './index.css';
import { trackEventLog } from '../../../core/utils'
import { COURSE_DETAIL } from '../../../config'
import Link from '../../common/Link'
import BlurImg from '../../common/BlurImg'
import CourseCard from '../../common/CourseCard'
import hitsDefault from '../../common/static/hitsDefault.png'

const slickDotsStyle = `
  .section-slide .slick-slider {
    position: relative;
  }

  .section-slide .slick-list {
    height: 288px;
  }

  .section-slide .slick-dots button {
    display: none;
  }
  .section-slide .slick-dots{
    position:absolute;
    height: 2px;
    bottom: 10px;
    left: 0;
    width: 100%;
    text-align: center;
  }
  .section-slide .slick-dots li{
    display: inline-block;
    height: 2px;
    width: 30px;
    background: #F7FFFF;
    line-height: 2px;
    vertical-align: top;
    margin: 0 2px;
    border-radius: 2px;
  }
  .section-slide .slick-dots .slick-active {
    background: #EE4137;
  }
  .section-slide .slick-arrow {
    position: absolute;
    top: 150px;
    height: 60px;
    width: 36px;
    background: rgba(0, 0, 0, 0.1);
    z-index: 10;
    display: none !important;
    cursor: pointer;
  }
  .section-slide .slick-slider:hover .slick-arrow {
    display: block !important;
  }
  .section-slide .slick-prev {
    left: 0px;
    background: url('https://ydschool-video.nosdn.127.net/1727408085307%E5%B7%A6%E6%8C%89%E9%92%AE_%E9%BB%98%E8%AE%A4%401x.png') center center no-repeat;
  }
  .section-slide .slick-arrow:hover {
    background: url('https://ydschool-video.nosdn.127.net/1727408085563%E7%82%B9%E5%87%BB%401x.png') center center no-repeat;
  }
  .section-slide .slick-next {
    right: 0px;
    background: url('https://ydschool-video.nosdn.127.net/1727408085308%E5%8F%B3%E6%8C%89%E9%92%AE_%E9%BB%98%E8%AE%A4%401x+%281%29.png') center center no-repeat;
  }
  .section-slide .slick-next:hover {
    background: url('https://ydschool-video.nosdn.127.net/1727408085560%E7%82%B9%E5%87%BB%401x_%E5%89%AF%E6%9C%AC.png') center center no-repeat;
  }
  .section-slide img {
    border-radius: 16px;
  }
`

const slideSetting = {
  dots: true,
  arrows: false,
  infinite: false,
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
}

class Section extends React.Component {

  static propTypes = {
    data: PropTypes.object.isRequired,
  }

  render() {
    const { data } = this.props
    /**
     * 因为后台偷懒不做限制
     * 所以只能前台这么傻的限制了 by zhulin
     */
    let sliceInx = 8
    if (data.head_img || data.pictures) {
      if (data.courses.length > 2 && data.courses.length < 6) {
        sliceInx = 2
      } else if (data.courses.length > 6 && data.courses.length < 8) {
        sliceInx = 6
      }
    } else if (data.courses.length > 4 && data.courses.length < 8) {
      sliceInx = 4
    }

    const settings = Object.assign({}, slideSetting, {
      infinite: true,
      speed: 500,
      arrows: false,
      autoplay: (data.pictures && data.pictures.length > 1),
    })
    const style = `
      ${slickDotsStyle}`;


    return (
      <div className={s.root}>
        <style dangerouslySetInnerHTML={{ __html: style.replace(/\t|\s{2,}/gi, '') }} />

        <div className={s.titleRow}>
          <h2 className={s.title}>
            {data.tag.displayName || data.tag.name}
          </h2>
          <Link
            className={s.more}
            onClick={() => { trackEventLog(`w/index/course/more/${data.tag.id}`) }}
            to={`/tag/${data.tag.id}`}
            extraParams={{ ptag: data.tag.id }}
          />
        </div>


        <div className={'section-slide'}>
          {data.head_img ?
            <Link
              onClick={() => { trackEventLog(`w/index/course/1/${data.tagId}`) }}
              className={s.headImgWrap}
              extraParams={{ inLoc: `fp_speCos_1_1_tag${data.tag.id}` }}
              to={`${COURSE_DETAIL}${data.head_courseId}`}
            >
              <BlurImg
                placeHolder={hitsDefault}
                addStyle={s.headImg}
                originSrc={data.head_img}
              />
            </Link> : null}
          {data.pictures ?
            <div className={s.sliderContainer}>
              <Slider {...settings}>
                {data.pictures.map(picture => (
                  <Link
                    onClick={() => { trackEventLog(`w/index/course/1/${data.tagId}`) }}
                    className={s.headImgWrap}
                    extraParams={{ inLoc: 'web_home_stagebanner', Pdt: 'jpkWeb' }}
                    to={picture.url}
                  >
                    <BlurImg
                      placeHolder={hitsDefault}
                      addStyle={s.headImgSlide}
                      originSrc={picture.img}
                    />
                  </Link>
                ))}
              </Slider>
            </div>
            : null}
          {
            data.courses.slice(0, sliceInx).map(course => (
              <CourseCard
                inLoc={'web_home_stagecourse'}
                hasBannerLayout={(!!data.head_img || !!data.pictures)}
                onClick={() => { trackEventLog(`w/index/course/2/${data.tagId}`) }}
                key={`home-sec-course-${course.id}`}
                data={course}
              />))
          }
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Section);



// WEBPACK FOOTER //
// ./src/components/p_home/Section/index.js